export default "__VITE_ASSET__SiWvVcNs__"